import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
import { ConnectionType } from '../../store/schema/ConnectionType';
export var resetConnectAdvancedStore = mutatorAction('resetConnectAdvancedStore', function (displayName, emailAddress, password, useNewFolder) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.displayName = displayName;
    store.connectAdvancedState.emailAddress = emailAddress;
    store.connectAdvancedState.password = password;
    store.connectAdvancedState.useNewFolder = useNewFolder;
    store.connectAdvancedState.isConnecting = false;
    store.connectAdvancedState.connectionType = ConnectionType.ImapSmtp;
    store.connectAdvancedState.useAltUsernamePassword = false;
    store.connectAdvancedState.imapServer = '';
    store.connectAdvancedState.popServer = '';
    store.connectAdvancedState.incomingPort = '993';
    store.connectAdvancedState.smtpServer = '';
    store.connectAdvancedState.outgoingPort = '587';
    store.connectAdvancedState.incomingAuth = 'Basic';
    store.connectAdvancedState.incomingSecurity = 'Ssl';
    store.connectAdvancedState.remoteSend = true;
    store.connectAdvancedState.altUsername = '';
    store.connectAdvancedState.altPassword = '';
    store.connectAdvancedState.leaveCopy = true;
});
//# sourceMappingURL=resetConnectAdvancedStore.js.map